import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

axios.defaults.withCredentials = true;

const AuthContext = createContext(null);
export const MEMBER_STATUSES = ["trialing", "active"];

const syncDevice = (u) => {
  if (!u) return;
  const local = localStorage.getItem("pp_device_id");
  if (u.family_device) { if (local !== u.family_device) localStorage.setItem("pp_device_id", u.family_device); }
  else localStorage.setItem("pp_device_id", crypto.randomUUID());
};

export const AuthProvider = ({ children }) => {
  const [user, setRawUser] = useState(null);
  const setUser = useCallback((u) => { syncDevice(u); setRawUser(u); }, []);
  const refreshUser = useCallback(() => axios.get(`${API}/auth/me`).then((r) => setUser(r.data)).catch(() => setUser(false)), [setUser]);
  useEffect(() => { refreshUser(); }, [refreshUser]);

  const login = useCallback(async (email, password) => { const { data } = await axios.post(`${API}/auth/login`, { email, password }); setUser(data); return data; }, [setUser]);
  const register = useCallback(async (body) => setUser((await axios.post(`${API}/auth/register`, body)).data), [setUser]);
  const logout = useCallback(async () => { await axios.post(`${API}/auth/logout`); setUser(false); }, [setUser]);
  const value = useMemo(() => ({ user, setUser, login, register, logout, refreshUser }), [user, setUser, login, register, logout, refreshUser]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
export const isMember = (u) => Boolean(u && (u.is_member ?? MEMBER_STATUSES.includes(u.subscription_status)));

export const startCheckout = async () => {
  const { data } = await axios.post(`${API}/billing/checkout`, { origin_url: window.location.origin });
  window.location.href = data.checkout_url;
};
export const cancelMembership = async () => (await axios.post(`${API}/billing/cancel`)).data;
export const resumeMembership = async () => (await axios.post(`${API}/billing/resume`)).data;
export const paymentStatus = async (id) => (await axios.get(`${API}/payments/status/${id}`)).data;
export const redeemCode = async (code) => (await axios.post(`${API}/billing/redeem`, { code })).data;
